// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Sawe1","importantInfo":"styles_importantInfo__3ukLq"};